var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTextIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "text-icon_svg__icon",
    d: "M11.941.625h-.882a.62.62 0 00-.577.396L2.642 21.75H1.437a.613.613 0 00-.616.61v.406c0 .336.276.609.616.609h4.518c.34 0 .616-.273.616-.61v-.406a.613.613 0 00-.616-.609H4.513l2.293-6.117h9.356l2.323 6.117h-1.44a.613.613 0 00-.617.61v.406c0 .336.276.609.616.609h4.518c.34 0 .616-.273.616-.61v-.406a.613.613 0 00-.616-.609h-1.205L12.518 1.02a.61.61 0 00-.577-.395zM7.425 13.998l3.887-10.22c.077-.195.139-.397.188-.58.049.182.11.383.187.578l3.856 10.222H7.425z",
    fill: "#C4C4C4"
  })));
}

export default __webpack_public_path__ + "./fonts/text-icon.832c91d289c9b37c7d8ada7a2e2774fc.svg";
export { SvgTextIcon as ReactComponent };